/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import EditorSaver from '../fw/EditorSaver';
import URLMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import handlers from '../view/box/apps/edit/handlers';
import IFrameEdit from '../view/box/apps/edit/IFrameEdit.react';
import AddRelationEdit from '../view/box/apps/edit/AddRelationEdit.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddonConfig.title', 'defaultMessage': 'Configuring Application Addon'}
});

interface ChannelAddonConfigProps {
    intl: IntlShape;
    user: User;
}

class ChannelAddonConfig extends React.Component<ChannelAddonConfigProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'channelAddons';
    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    save = (options) => {
        let channelAddonFatQuery = Relay.QL `fragment on UpdateChannelAddonPayload {
                                    updatedNode {
                                        id,
                                        options,
                                    },
                                }`;
        let channelAddonMutation = Relay.QL `mutation { updateChannelAddon }`;

        let channelAddon = this.props.user.organisation.channel.channelAddon;
		// eslint-disable-next-line max-params
        let fce = function (data, storeData, defaultValue, columns) {
            storeData['options'] = JSON.stringify(options);
            storeData['id'] = channelAddon['id'];

            return storeData;
        };

        let saver = new EditorSaver(types['channelAddons'], channelAddonMutation, channelAddonFatQuery, null, null, fce);
        return saver.save({}).then(() => {
            let path = URLMapping.getUrl(types['channelAddons'], "view", channelAddon);
            this.context.router.push(path);
        });
    };

    render() {
        let channel = this.props.user.organisation.channel;
        let data = channel.channelAddon;
        let type = types[this.typeName];

        let handlerName = null;

        if (this.props.user.organisation.channel.channelAddon.addonDef) {
            handlerName = this.props.user.organisation.channel.channelAddon.addonDef.handler;
        }

        let handler = handlers[handlerName];

        let content = null;
        if (handler) {
            content = React.createElement(handler.handler, {
                channelAddon: data,
                save: this.save
            });
        }

        return (
            <AppPanel breadcrumbParams={[
                {type: type, data: data},
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['channels'], data: channel},
            ]}  title={this.props.intl.formatMessage(messages.title)}>
                {content}
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddonConfig), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.channelAddon;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        channelAddonId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
               organisation(id: $organisationId) {
                   id,
                   realId,
                   name,
                   channel(id: $channelId) {
                       id,
                       name,
                       organisation_id,
                       options,
                       channelDef {
                           id,
                           name
                       },
                       channelAddon(id: $channelAddonId) {
                           id,
                           realId,
                           organisation_id,
                           channel_id,
                           name,
                           options,
                           organisation {
                               id
                               channels(first: 100, deleted: false) {
                                   edges {
                                       node {
                                            id,
                                            realId,
                                            organisation_id,
                                            name,
                                            channelDef {
                                                id,
                                                name,
                                                icon,
                                            }
                                       }
                                   }
                               }
                           },
                           addonDef {
                               id,
                               name,
                               handler,
                               allowConnectedChannelSelection,
                           },
                           ${IFrameEdit.getFragment('channelAddon')}
                           ${AddRelationEdit.getFragment('channelAddon')}
                       }
                   }
               }
            }
        `,
    },
});
